module.exports = __webpack_public_path__ + "media/images/book-f532f241c8eb3d055a3d9e41c338b73f.svg";